import { render, staticRenderFns } from "./rotasAssoc.vue?vue&type=template&id=c057d5a8&scoped=true"
import script from "./rotasAssoc.vue?vue&type=script&lang=js"
export * from "./rotasAssoc.vue?vue&type=script&lang=js"
import style0 from "./rotasAssoc.vue?vue&type=style&index=0&id=c057d5a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c057d5a8",
  null
  
)

export default component.exports